import {createAction, props} from '@ngrx/store';
import {Filtro} from '~model/filtro/filtros/filtro';
import {RotaVo} from '~model/vo/rota-vo';

export enum FeatureFiltroActionsTypes {
  SetInputFilter = '[Filtro] setInput',
  Reiniciar = '[Filtro] reiniciar'
}

export const filtroSetInput = createAction(
  FeatureFiltroActionsTypes.SetInputFilter,
  props<{ filtros: Filtro<RotaVo>[] }>()
);

export const filtroReiniciar = createAction(
  FeatureFiltroActionsTypes.Reiniciar
);
